import { format, parseISO } from "date-fns";

const SIGNATURE_DATE_FORMAT = {
  API: "yyyy-MM-dd",
  DISPLAY: "dd/MM/yyyy",
} as const;

const SIGNATURE_ELEMENT_ID = "signature";

export const BUYER_REQUEST_ERROR = {
  MISSING_NAME: "Your name is not available. Please reload your profile before signing.",
  MISSING_SIGNATURE: "Buyer request signature area is missing.",
  LOAD_FAILED: "Unable to load the buyer request form. Please try again.",
} as const;

export type BuyerRequestSignature = {
  signature_name: string;
  signature_date: string;
};

export const createBuyerRequestSignature = (
  firstName?: string | null,
  lastName?: string | null,
): BuyerRequestSignature => {
  const signatureName = [firstName?.trim(), lastName?.trim()].filter(Boolean).join(" ");
  if (!signatureName) throw new Error(BUYER_REQUEST_ERROR.MISSING_NAME);

  return {
    signature_name: signatureName,
    signature_date: format(new Date(), SIGNATURE_DATE_FORMAT.API),
  };
};

export const populateBuyerRequestSignature = (
  body: string,
  signature: BuyerRequestSignature,
): string => {
  const templateDocument = new DOMParser().parseFromString(body, "text/html");
  const signatureElement = templateDocument.getElementById(SIGNATURE_ELEMENT_ID);
  if (!signatureElement) throw new Error(BUYER_REQUEST_ERROR.MISSING_SIGNATURE);
  signatureElement.replaceChildren();
  const name = templateDocument.createElement("span");
  name.textContent = signature.signature_name;
  const date = templateDocument.createElement("span");
  date.textContent = `Date: ${format(parseISO(signature.signature_date), SIGNATURE_DATE_FORMAT.DISPLAY)}`;
  signatureElement.append(name, templateDocument.createElement("br"), date);
  return templateDocument.documentElement.outerHTML;
};
